import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { Endpoints } from '../../Global/Endpoints';
import { useSelector } from "react-redux";

const IFramePage = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const { htmlContent, externalData } = location.state || {};
    const token = localStorage.getItem('AccessToken');
    const userInfo = useSelector((state) => state.userData);
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const effectiveUserData = externalData ? externalData : userInfo?.userData;
    if (!htmlContent) {
        return <p>Error: No content to display.</p>;
    }
    const logClickActivity = async (link) => {
        const params = {
            EmailID: effectiveUserData?.EmailID || "Unknown",
            Activity: `ProviderSearch:${link}`,
            DeviceType: effectiveUserData?.DeviceType || (isHighmarkPortal ? "HighmarkPortal" : "PatientPortal"),
        };
        try {
            const response = await axios.post(
                Endpoints.CallRecoderLog,
                { _Params: JSON.stringify(params) },
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Connection": "close",
                        "Accept": "*/*",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data) {
                console.log("Log saved successfully:", response.data);
            } else {
                console.warn("Log not saved: Empty response from server.");
            }
        } catch (error) {
            console.error("Error saving log:", error);
        }
    };


    // Parse the XML content
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(htmlContent, "text/xml");

    // Get valid provider with non-empty link and logo
    const providers = Array.from(xmlDoc.querySelectorAll("provider")).filter((provider) => {
        const link = provider.querySelector("providerlink")?.textContent.trim();
        const logo = provider.querySelector("providerlogo")?.textContent.trim();
        return link && logo; // Only include providers with both link and logo
    });

    const provider = providers[0]; // Use the first valid provider
    const providerLink = provider?.querySelector("providerlink")?.textContent.trim();
    const providerLogo = provider?.querySelector("providerlogo")?.textContent.trim();
    const providerText = xmlDoc.querySelector("providertext")?.textContent.trim();

    return (
        <div className="container mt-4">
            {/* Back Button */}
            <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
                <button
                    className="win-back-btn"
                    onClick={() => window.history.back()}
                >
                    <span>
                        <i className="bi bi-chevron-left"></i> {t('back')}
                    </span>
                </button>
                <h2 className="page-heading">&nbsp;</h2>
                <h2 className="page-heading">{t('choserenetworks')}</h2>
            </div>

            {/* Heading */}
             
             {providerText && <p className="mt-5 p-5">{providerText}</p>}

          {/* Provider Logos */}
          {providers.map((provider, index) => {
                const providerLink = provider.querySelector("providerlink")?.textContent.trim();
                const providerLogo = provider.querySelector("providerlogo")?.textContent.trim();
                return (
                    <div key={index} style={{ marginBottom: "20px" }}>
                        <a
                            href={providerLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                                logClickActivity(providerLink); // Log the activity
                            }}
                        >
                            <img
                                src={providerLogo}
                                alt={`Provider Logo ${index + 1}`}
                                onError={(e) => {
                                    e.target.onerror = null; // Prevent infinite loop
                                    e.target.src = "https://via.placeholder.com/200"; // Fallback image
                                }}
                                style={{
                                    maxWidth: "200px",
                                    height: "auto",
                                    margin: "0 auto",
                                    display: "block",
                                    cursor: "pointer", // Hand cursor on hover
                                }}
                            />
                    </a>
                    </div>
                );
            })}
            {/* {isChatVisible && <ChatBotWindow />} */}
        </div>
    );
};

export default IFramePage;
